import React from 'react';
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {makeStyles} from "@material-ui/styles";
import {Link} from "react-router-dom";

export default function UsersTable({users}) {
    const classes = useStyles();
    return (
        <Paper variant="outlined" className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{minWidth: column.minWidth}}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((row) => {
                            return (
                                <TableRow hover tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        const isId = column.id === 'name';
                                        return (
                                            <TableCell key={column.id} component={isId && Link}
                                                       to={isId && "/devices"} align={column.align}>
                                                {column.format ? column.format(value) : value}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>

    );
}


const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});


const columns = [
    {id: 'name', label: 'نام', minWidth: 170},
    {id: 'role', label: 'نقش', minWidth: 100,},
    {id: 'emailAddress', label: 'آدرس ایمیل', minWidth: 100},
    {id: 'phoneNumber', label: 'شماره تلفن', minWidth: 120},
    {
        id: 'createdAt',
        label: 'اضافه‌شده در',
        minWidth: 120,
        format: (value) => new Intl.DateTimeFormat('fa-IR').format(new Date(value)),
    },
];
